module.exports = __webpack_public_path__ + "img/404-icon.51cf494d.png";